import type { MealName } from "./types";

export const MEAL_OPTIONS: ReadonlyArray<{ readonly value: MealName; readonly label: string }> = [
  { value: "Breakfast", label: "Breakfast" },
  { value: "Lunch", label: "Lunch" },
  { value: "Dinner", label: "Dinner" },
  { value: "Snack", label: "Snacks" },
];

export function mealLabel(meal: MealName): string {
  return meal === "Snack" ? "Snacks" : meal;
}
